import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { Button, CircularProgress, IconButton } from "@mui/material";
import { ThemeProvider } from "@emotion/react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AppContext } from "../../../context/AppContext";
import Input from "@mui/joy/Input";
import EditIcon from "@mui/icons-material/Edit";
import theme from "../../../themes/theme";
import AdminLayout from "../../../components/AdminDashboard/AdminLayout/AdminLayout";
import BASE_URL from "../../../config/api";
import Textarea from "@mui/joy/Textarea";
import axios from "axios";
import "./EditCourse.css";
import AdminCoursePreview from "./AdminCoursePreview/AdminCoursePreview";

export default function EditCourse() {
  const { id } = useParams();
  const { token } = useContext(AppContext);

  const [course, setCourse] = useState(null);
  const [createdAt, setCreatedAt] = useState("");
  const [updatedAt, setUpdatedAt] = useState("");
  const [loading, setLoading] = useState(true);
  const [editedCourse, setEditedCourse] = useState({
    title: "",
    description: "",
    instructor: "",
    rating: "",
    image: null,
  });

  const [message, setMessage] = useState("");
  const [incorrectStyles, setIncorrectStyles] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const colorMessage = incorrectStyles ? "#f00" : "#000";
  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  useEffect(() => {
    const fetchCourseDetails = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/courses/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setCourse(response.data);
        setEditedCourse({
          title: response.data.title,
          description: response.data.description,
          instructor: response.data.instructor,
          rating: response.data.rating,
          image: response.data.image,
        });
        setCreatedAt(formatDate(response.data.createdAt));
        setUpdatedAt(formatDate(response.data.updatedAt));
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    if (token) fetchCourseDetails();
  }, [id, token]);

  const handleInputChange = (field, value) => {
    setEditedCourse((prevCourse) => ({
      ...prevCourse,
      [field]: value,
    }));
  };
  const handleDescriptionChange = (e) => {
    const inputValue = e.target.value;

    if (inputValue.length <= 100) {
      setEditedCourse((prev) => ({
        ...prev,
        description: inputValue,
      }));
    }
  };

  const handleDeleteCourse = async () => {
    try {
      await axios.delete(`${BASE_URL}/courses/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      toast.success("Course deleted");

      window.location.href = `/admin/${id}`;
    } catch (err) {
      setIsSuccess(false);
      setIncorrectStyles(true);
      setMessage(err.response ? err.response.data.err : err.message);
    }
  };

  const handleUpdateCourse = async () => {
    const requestData = {
      title: editedCourse.title,
      description: editedCourse.description,
      instructor: editedCourse.instructor,
      rating: editedCourse.rating,
      image: editedCourse.image,
    };

    try {
      await axios.put(`${BASE_URL}/courses/${id}`, requestData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      toast.success("Course updated successfully");
      window.location.href = `/admin/${id}`;
      setIsSuccess(true);
      setMessage("Course updated successfully!");
      setIncorrectStyles(false);
    } catch (err) {
      setIsSuccess(false);
      setIncorrectStyles(true);
      setMessage(err.response.data.errors[0].msg);
      toast.error(err.response.data.errors[0].msg);
    }
  };

  if (loading) {
    return <CircularProgress />;
  }

  return (
    <>
      <AdminLayout>
        <ToastContainer position="bottom-right" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} />
        {message && (
          <div style={{ color: colorMessage, marginTop: "10px" }}>
            {isSuccess ? "Success: " : "Error: "} {message}
          </div>
        )}
        <div className="create-form-wrapper" sx={{ flexDirection: "column" }}>
          <div className="edit-course-container">
            <div className="edit-form">
              <h2>Edit Course</h2>
              <label>Course title</label>
              <div className="input-container">
                <Input variant="soft" label="Title" value={editedCourse.title} onChange={(e) => handleInputChange("title", e.target.value)} />
                <IconButton>
                  <EditIcon />
                </IconButton>
              </div>
              <label>Course description</label>

              <div className="input-container">
                <Textarea variant="soft" required rows={4} placeholder="Max 100 characters" name="description" value={editedCourse.description} onChange={handleDescriptionChange}></Textarea>
                <IconButton>
                  <EditIcon />
                </IconButton>
              </div>
              <label>Course lecturer</label>
              <div className="input-container">
                <Input variant="soft" label="Lecturer" value={editedCourse.instructor} onChange={(e) => handleInputChange("instructor", e.target.value)} />
                <IconButton>
                  <EditIcon />
                </IconButton>
              </div>
              <label>Level</label>

              <div className="input-container">
                <Input variant="soft" label="Rating" value={editedCourse.rating} onChange={(e) => handleInputChange("rating", e.target.value)} />
                <IconButton>
                  <EditIcon />
                </IconButton>
              </div>
              <div className="input-container">
                <label>Created at</label>
                <Input variant="soft" label="Created at" value={createdAt} disabled />
              </div>
              <div className="input-container">
                <label>Last updated</label>
                <Input variant="soft" label="Last updated" value={updatedAt} disabled />
              </div>
              {/* <label>Course Image</label>
          <p>*only JPG files are allowed</p>
          <ImageUploadPreview
            onImageChange={handleImageChange}
            imageUrl={`${BASE_URL}/courses/${id}/image`}
          /> */}

              <ThemeProvider theme={theme}>
                <Button sx={{ margin: "10px" }} variant="contained" onClick={handleUpdateCourse}>
                  Update Course
                </Button>
              </ThemeProvider>
              <ThemeProvider theme={theme}>
                <Button sx={{ margin: "10px" }} variant="outlined" onClick={handleDeleteCourse}>
                  Delete Course
                </Button>
              </ThemeProvider>
            </div>
            {/* <div className="admin-preview">
              <AdminCoursePreview course={editedCourse} id={id} />
            </div> */}
          </div>
        </div>
      </AdminLayout>
    </>
  );
}
